export default "__VITE_ASSET__BZ138wxX__"